import dayjs from 'dayjs';

const statusHashMap = {
    AUTHORIZED: 'Одобрен',
    CONFIRMED: 'Подтверждён',
    NEW: 'Новый',
    REJECTED: 'Отклонен',
};

const typeHashMap = {
    subscription: 'Подписка',
    tariff: 'Тариф',
    publication: 'Публикация',
    donate: 'Донат',
};
export const getColumns = () => [
    {
        title: 'ID',
        dataIndex: 'order_id',
        key: 'order_id',
        width: '152px',
        render: text => text,
    },
    {
        title: 'Время платежа',
        dataIndex: 'created_at',
        key: 'order_id',
        width: '152px',
        ellipsis: true,
        render: time => dayjs.unix(time).format('DD.MM.YY HH:mm'),
    },
    {
        title: 'Пользователь',
        dataIndex: 'telegram_user_name',
        key: 'order_id',
        width: '167px',
        ellipsis: true,
        render: text => text,
    },
    {
        title: 'Тип',
        dataIndex: 'type',
        key: 'order_id',
        width: '152px',
        ellipsis: true,
        render: text => typeHashMap[text] || text,
    },
    {
        title: 'Сообщество',
        dataIndex: 'community',
        key: 'order_id',
        width: '167px',
        ellipsis: true,
        render: text => text,
    },
    {
        title: 'Статус',
        dataIndex: 'status',
        key: 'order_id',
        width: '167px',
        ellipsis: true,
        render: text => statusHashMap[text] || text,
    },
    {
        title: 'Сумма поступлений',
        dataIndex: 'add_balance',
        key: 'order_id',
        width: '167px',
        ellipsis: true,
        align: 'right',
        render: text => text || 0,
    },
];
